
$(document).ready(function($) {

    flatpickr("#leisure-bedroom-checkin", { // Check-In and Check-Out flatpickr instance
		mode: "range",
		altFormat: "Y-m-d",
		dateFormat: "Y-m-d",
        months: 2,
        minDate: "today",

        
        "plugins": [new rangePlugin({ input: "#leisure-bedroom-checkout"})]
    });
});


